import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { NavigationMenu, Provider, RoutePropagator } from '@shopify/app-bridge-react';
import { AppProvider, Frame } from '@shopify/polaris';
import { useSelector } from 'react-redux';
import { getAllUserOnboarding } from '../redux/userOnboarding/slice';
import SettingPage from '../pages/Setting';
import AppOverviewPage from '../pages/AppOverview';
import SetupMetafieldPage from '../pages/SetupMetafield';
import PriceUpdateLogPage from '../pages/PriceUpdateLogs';
import PricingPlanPage from '../pages/PricingPlan';
import ContactUsPage from '../pages/ContactUs';
import ConfigureProductsPage from '../pages/ConfigureProducts';
// import ConfigureProductVariantPage from '../pages/ConfigureProductVariant';
import CreateRulePage from '../pages/CreateRule';
import RulesPage from '../pages/Rules';
import { config_variable } from '../helper/commonApi';
import enTranslations from '@shopify/polaris/locales/en.json';
import { REDIRECT_PATHS, isAdmin } from '../utils';

export function Router() {
    const location = useLocation();
    const navigate = useNavigate();
    const { userOnboardingData } = useSelector(getAllUserOnboarding);

    useEffect(() => {
        const isAllowedPath = location?.pathname.startsWith('/update-rule/') || REDIRECT_PATHS.includes(location?.pathname);
        if (userOnboardingData?.is_onboarding && !isAllowedPath) {
            navigate('/price-update-logs');
        }
    }, [userOnboardingData, location?.pathname]);

    if (!config_variable.config.host) {
        config_variable.config.host = location?.state?.config?.host ? location?.state?.config?.host : config_variable.config.host;
        config_variable.shop_name = location?.state?.shop_name ? location?.state?.shop_name : config_variable.shop_name;
    }

    return (
        <AppProvider i18n={enTranslations}>
            {isAdmin ?
                <Provider config={config_variable.config}>
                    <NavigationMenu
                        navigationLinks={userOnboardingData?.is_onboarding ? [
                            {
                                label: 'Setting',
                                destination: REDIRECT_PATHS[4]
                            },
                            {
                                label: 'Price Update Logs',
                                destination: REDIRECT_PATHS[2]
                            },
                            {
                                label: 'Rules',
                                destination: REDIRECT_PATHS[8]
                            },
                            {
                                label: 'Create Rule',
                                destination: REDIRECT_PATHS[7]
                            },
                            // {
                            //     label: 'Configure Products',
                            //     destination: REDIRECT_PATHS[0]
                            // },
                            {
                                label: 'Setup Metafield',
                                destination: REDIRECT_PATHS[1]
                            },
                            {
                                label: 'Contact Us',
                                destination: REDIRECT_PATHS[3]
                            },
                        ] : []}
                        matcher={(link, location) => link.destination === location.pathname} />
                    <Frame>
                        <RoutePropagator location={location} />
                        <Outlet />
                    </Frame>
                </Provider> : <Outlet />
            }
        </AppProvider>
    );
}

export const routes = [
    { path: '/', component: <AppOverviewPage /> },
    { path: REDIRECT_PATHS[0], component: <ConfigureProductsPage /> },
    { path: REDIRECT_PATHS[1], component: <SetupMetafieldPage /> },
    { path: REDIRECT_PATHS[2], component: <PriceUpdateLogPage /> },
    { path: REDIRECT_PATHS[3], component: <ContactUsPage /> },
    { path: REDIRECT_PATHS[4], component: <SettingPage /> },
    { path: REDIRECT_PATHS[5], component: <PricingPlanPage /> },
    // { path: REDIRECT_PATHS[6], component: <ConfigureProductVariantPage /> },
    { path: REDIRECT_PATHS[7], component: <CreateRulePage /> },
    { path: REDIRECT_PATHS[8], component: <RulesPage /> },
    { path: REDIRECT_PATHS[9], component: <CreateRulePage /> },
    { path: '*', component: <PriceUpdateLogPage /> }
];
